import React, { useContext } from "react"
import axios from "axios"
import { Context } from "../../components/store/UserProvider"

const useComments = (
  comment,
  videoId,
  disMode,
  id = null,
  user_name = null,
  original_post = null,
  nav_id
) => {
  const ctx = useContext(Context)

  const sendData = () => {
    const formdata = JSON.stringify({
      data: {
        user_name: ctx.userGlobalState.name,
        content: comment,
        original_post: disMode === "reply-sub" ? original_post : "",
        original_author: disMode === "reply-sub" ? user_name : "",
        nav_id: disMode === "reply-sub" ? nav_id : null,
        position: disMode,
        main_post_id: id ? id : null,
        video_id: videoId,
        user_id: ctx.userGlobalState.userId,
        date_time: new Date(),
        lesson: videoId,
      },
    })

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ctx.userGlobalState.token}`,
      },
      body: formdata,
      redirect: "follow",
    }

    fetch("https://montessori-back.herokuapp.com/api/comments", requestOptions)
      .then(response => response.text())
      .then(result => console.log(result))
      .catch(error => console.log("error", error))
      .finally(() => {
        ctx.setNavToNewPost(true)
        ctx.setRefreshCommetnsCounter(state => {
          return state + 1
        })
      })
  }

  return {
    sendData,
  }
}

export default useComments

// const sendData = () => {
//   console.log("SENDING")
//   axios
//     .post("https://montessori-back.herokuapp.com/api/comments", {
//       data: {
//         user_name: ctx.userGlobalState.name,
//         content: comment,
//         original_post: disMode === "reply-sub" ? original_post : "",
//         original_author: disMode === "reply-sub" ? user_name : "",
//         nav_id: disMode === "reply-sub" ? nav_id : null,
//         position: disMode,
//         main_post_id: id ? id : null,
//         video_id: videoId,
//         user_id: ctx.userGlobalState.userId,
//         date_time: new Date(),
//         lesson: videoId,
//       },

//       headers: {
//         Authorization: `Bearer ${ctx.userGlobalState.token}`,
//       },
//     })
//     .then(response => {
//       console.log("sent comment", response.data)
//     })
//     .catch(error => {
//       console.log("An error occurred:", error.response)
//     })
//     .finally(() => {
//       ctx.setRefreshCommetnsCounter(state => {
//         return state + 1
//       })
//     })
// }
